import React from "react";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import "./InputBox.css";

interface TextInputProps {
  label: string;
  required?: boolean;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: "text" | "email" | "password" | "number" | "date" | "datetime-local";
  showPasswordToggle?: boolean;
  showPassword?: boolean;
  onTogglePassword?: () => void;
  maxLength?: number;
  name?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  max?: string;
}

const InputBox: React.FC<TextInputProps> = ({
  label,
  required,
  placeholder,
  value,
  onChange,
  type = "text",
  showPasswordToggle = false,
  showPassword = false,
  onTogglePassword,
  maxLength,
  name,
  disabled = false,
  style,
  max,
}) => {
  const EyeOpenIcon = AiOutlineEye as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  const EyeOffIcon = AiOutlineEyeInvisible as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  return (
    <>
      <label className="input-label">
        {label} {required && <span className="required">*</span>}
      </label>
      <div className="input-wrapper">
        <input
          type={
            showPasswordToggle ? (showPassword ? "text" : "password") : type
          }
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            if (
              type === "number" &&
              maxLength &&
              e.target.value.length > maxLength
            ) {
              e.target.value = e.target.value.slice(0, maxLength);
            }
            onChange(e);
          }}
          required={required}
          className="input-field"
          maxLength={maxLength}
          disabled={disabled}
          style={style}
          max={max}
          onWheel={(e) => e.currentTarget.blur()} //disables mouse scroll
          onKeyDown={(e) => {
            if (
              type === "number" &&
              (e.key === "ArrowUp" || e.key === "ArrowDown")
            ) {
              e.preventDefault(); //disables arrow key increment/decrement
            }
          }}
        />
        {showPasswordToggle && (
          <button
            type="button"
            className="toggle-button"
            onClick={onTogglePassword}
            aria-label="Toggle password visibility"
          >
            {showPassword ? (
              <EyeOffIcon style={{ color: "#28606B" }} />
            ) : (
              <EyeOpenIcon style={{ color: "#28606B" }} />
            )}
          </button>
        )}
      </div>
    </>
  );
};

export default InputBox;
